import { Component,ViewChild, AfterViewInit ,ChangeDetectorRef} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MatPaginator, MatSort} from '@angular/material';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { DataUserService } from '../../../Services/data-user.service';
import { DataApiService } from '../../../Services/data-api.service';
import { DialogCopyPedidoComponent } from '../../../components/dialogs/dialog-copy-pedido/dialog-copy-pedido.component';
import { VerDatosUsuarioPorServicioComponent } from '../../../components/dialogs/ver-datos-usuario-por-servicio/ver-datos-usuario-por-servicio.component';
import { InformacionPedidoComponent } from '../informacion-pedido/informacion-pedido.component';
import { User } from '../../../interfaces/users';

@Component({
  selector: 'app-abrir-asignacion-de-usuarios',
  templateUrl: './abrir-asignacion-de-usuarios.component.html',
  styleUrls: ['./abrir-asignacion-de-usuarios.component.scss']
})
export class AbrirAsignacionDeUsuariosComponent implements AfterViewInit { 

  exampleDatabase: ExampleHttpDatabase | null;
  data: GithubIssue[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  itemPerPage = 8;
  idUser = this.DataUser.dataUser(this.dataApi.tokenUser(localStorage.getItem("token")));
  typeUser = localStorage.getItem("type");
  typeUserEmpresa = localStorage.getItem("tipoUsuarioEmpresa"); 

 
  displayedColumns: string[] = [
    'datos',
    'acciones' 
  ];
  
  public error = null;
  users:User[];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private http: HttpClient,    
    private DataUser:DataUserService,
    private dataApi:DataApiService,
    private dialog: MatDialog,    
  ){} 
  

  errorPriceNoNumeric:string= null;
  /**
   *
   * formulario asignacion 
   */
  public formAsignar={
    id_pedido:null,
    usuario_motorizado:null
  }
  


  verDatosUsuario(row){
    this.dialog.open(VerDatosUsuarioPorServicioComponent,{
      width:"40%",
      data:{row},
      disableClose: false,
      autoFocus:true
    }); 
  
  }
  select(event){
    const estado = event.value;
    this.reset(estado)
    
  }

  ngAfterViewInit() {
    this.listaUsuariosMotorizados();
    this.reset("ambos");    
  }
  
  reset(state){
    this.exampleDatabase = new ExampleHttpDatabase(this.http,this.dataApi);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.exampleDatabase!.getRepoIssues(
            this.typeUserEmpresa,this.typeUser,state,this.idUser,this.sort.active, this.sort.direction, this.paginator.pageIndex);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);  
  }

 
  cerrarForm(id_pedido){
    (document.querySelector(".formEstado_"+id_pedido) as HTMLElement).style.display ="none";
  }

 
    
  detectarUsuario(usuario_asignado){
    return usuario_asignado=="" ? "Por asignar" : usuario_asignado;
  }

  listaUsuariosMotorizados(){
    this.dataApi.obtenerUsuariosMotorizados().subscribe((data:User[])=>{
      this.users = data;       
    });
  }

  abrirPanelAsignarMotorizado(id_pedido){
    this.formAsignar.id_pedido = id_pedido;
    document.querySelector(".seleccionar_motorizado--"+id_pedido).classList.add("block");
  }
  cerrarPanelAsignarMotorizado(id_pedido){
    this.formAsignar.id_pedido = "";
    this.formAsignar.usuario_motorizado="";
    document.querySelector(".seleccionar_motorizado--"+id_pedido).classList.remove("block");
  }

  asignarUsuario(){
    this.dataApi.asignarMotorizados(this.formAsignar).subscribe(
      (data)=>this.handleResponse(data),
      (error)=>this.handleError(error)
    )
  }

  handleResponse(data){
    const usuario_motorizado = this.formAsignar.usuario_motorizado;
    const id_solicitud = this.formAsignar.id_pedido;
    document.querySelector(".usuarioAsignado--"+id_solicitud).querySelector("p").innerHTML = usuario_motorizado;
    document.querySelector(".seleccionar_motorizado--"+id_solicitud).classList.remove("block");
    this.formAsignar.id_pedido = "";
    this.formAsignar.usuario_motorizado="";
   
  }
  
  handleError(error){
    console.log(error);
  }

  
  /*copiar pedido */
  copyPedido(row){    
    this.dialog.open(DialogCopyPedidoComponent,{
      width:"40%",
      data:{datos:row},
      disableClose: false,
      autoFocus:true
    });   
   
    const pedidoWatsapp = `
      N° Pedido : ${row.id_pedido}
      Lugar de recojo: ${row.lugarRecojo}
      Fecha de recojo : ${row.fechaRecojo}
      Hora de recojo : ${row.horaEntrega}
      Observaciones recojo : ${row.observaciones_recojo}
      Lugar de entrega: ${row.lugarEntrega}
      Fecha de entrega : ${row.fechaEntrega}
      Hora de entrega : ${row.horaEntrega}
      Observaciones entrega : ${row.observaciones_entrega}
      Retorno : ${(row.retorno==1)?"SI" : "NO"}
      COD : ${(row.cod==1)?"SI" : "NO"}
      Descripción :${row.descripcion}  
    `;
    const aux = document.createElement("textarea");
    aux.value= pedidoWatsapp;
    document.body.appendChild(aux);
    aux.select();
    document.execCommand("copy");
    document.body.removeChild(aux);
  } 

  informacionPedido(row){    
    this.dialog.open(InformacionPedidoComponent,{
      width:"340px",
      data:{row},
      disableClose: false,
      autoFocus:true
    }); 
  }
  
 

}

export interface GithubApi {
  items: GithubIssue[];
  total_count: number;
}

export interface GithubIssue {
  id_pedido:number,
  usuario_asignado:string,
  cod:number,
  retorno:number,
  lugarRecojo:string,
  fechaRecojo:any,
  horaRecojo:any,
  observaciones_recojo:string,
  lugarEntrega:string,
  fechaEntrega:any,
  horaREntrega:any,
  observaciones_entrega:string,
  tipoPago:number,
  RUCFactura:string,
  RazonSocialFactura:string,
  descripcion:string,
  precio:any,
  precio_convenio:any,
  modoPago:any,
  fecha_por_atender:any,
  fecha_recogido:any,
  fecha_entregado:any,
  fecha_devolucion:any,
  fecha_anulado:any,
  liquidado:number,
  nombre_comercial:string,
  name:string,
  surname:string,
  convenio:number,
  estado:number,
  email:string
  
}

/** An example database that the data source uses to retrieve data for the table. */
export class ExampleHttpDatabase{
  constructor(
    private http: HttpClient,
    private dataApi:DataApiService

  ) {}

  getRepoIssues(typeUserEmpresa:string,typeUser:string,state:any,idUser:number,sort: string, order: string, page: number): Observable<GithubApi> {     
    const href = this.dataApi.url;
    const requestUrl =
        `${href}/asignarPedidos/${page + 1}/8/${idUser}/${typeUser}/${typeUserEmpresa}/${state}`;

    return this.http.get<GithubApi>(requestUrl);
  }

 
  
}

